<script>
    import { onMount } from "svelte";
    import { g } from "../../../shared/globalState/g";

    let canvas;

    onMount(()=>{
        g.init(canvas);
    })
</script>
<canvas class="drawing" bind:this={canvas}></canvas>
<style></style>
